import BaseComponent from '../base-component/base-component'
import { Nullable } from '../../types/common'

class PasswordField extends BaseComponent {
  inputSelector: string
  buttonSelector: string
  input: Nullable<HTMLInputElement>
  button: Nullable<HTMLElement>

  constructor() {
    super()

    this.inputSelector = `[data-password-field-input]`
    this.buttonSelector = `[data-password-field-button]`

    this.input = this.querySelector(this.inputSelector)
    this.button = this.querySelector(this.buttonSelector)
  }

  connectedCallback(): void {
    this.button.addEventListener('click', this.handleButtonClick)
  }

  disconnectedCallback(): void {
    this.button.removeEventListener('click', this.handleButtonClick)
  }

  handleButtonClick = (): void => {
    this.togglePasswordVisible()
  }

  togglePasswordVisible(): void {
    if (this.input) {
      const isPasswordHidden = this.input.getAttribute('type') === 'password'
      const type = isPasswordHidden ? 'text' : 'password'

      this.input.setAttribute('type', type)

      this.setButton(isPasswordHidden)
    }
  }

  setButton(isPasswordHidden: boolean): void {
    if (this.button) {
      this.button.toggleAttribute('password-visible', isPasswordHidden)
    }
  }
}

export default PasswordField
